

//Redirect Customer to login page when they ara comming back form checkout.
if (window.location.pathname == "/account/login") {
var checkout_url = getUrlVars()["checkout_url"];
if (checkout_url) {
window.location.href = "/account/login";
}
}
//get query string from URL
function getUrlVars() {
var vars = [], hash;
var hashes = window.location.href.slice(window.location.href.indexOf("?") + 1).split("&");
for (var i = 0; i < hashes.length; i++) {
hash = hashes[i].split("=");
vars.push(hash[0]);
vars[hash[0]] = hash[1];
}
return vars;
}

ACDiscountApp.CartPage.Show_CalculateTier = function () {
 let customerMemberOrNot = globalFields.customerTagsCheck();
  let finalDiscountObj = []
 let TradeCustomer = false; 
 let originalCartObjPrice = []
  var postDataDiscountArrayObject = [];
  var discountMsg = "TIERED_DISCOUNT";
  let originalCartObjData = []
 var currencyRate = Shopify.currency.rate;
  let checkOutValid = false;
 TradeCustomer = customerMemberOrNot == 'Trade+' ? true :false;  
function hasCoustomerTag() {
    customerMemberOrNot = globalFields.customerTagsCheck();
    TradeCustomer = customerMemberOrNot == 'Trade+' ? true :false;
}
  hasCoustomerTag()

  // Utility function to create a discount object, used in all three discount types.
  function createDiscountObject(msg, variantId, qty,value) {
    return {
      message: msg,
      targets: [{ productVariant: { id: variantId } }],
      value: value,
    };
  }

  
  
  // Creates a fixed amount discount object and calculates the total discount amount.
  function createAmountOffDiscountObject(msg,variantId,currencyRate,amount,qtys) {
    const totalDiscountedAmount = (amount * currencyRate * qtys).toFixed(2);
    return createDiscountObject(msg, variantId, qtys,{
      fixedAmount: { amount: totalDiscountedAmount },
    });
  }



async function setDateTimeInCart() {
  try {
    const DiscountObj = Object.values(finalDiscountObj).map((item) => {
  return createAmountOffDiscountObject(
    item.discountMsg,
    `gid://shopify/ProductVariant/${item.variant_id}`,
    currencyRate,
    item.tierPrice,
    item.qty
  );
});

//console.log(DiscountObj);
//     
    // Group and merge by productVariant.id
const grouped = {};

DiscountObj.forEach(item => {
  const id = item.targets[0].productVariant.id;
  const amount = parseFloat(item.value.fixedAmount.amount);

  if (!grouped[id]) {
    grouped[id] = {
      message: item.message,
      targets: item.targets,
      value: {
        fixedAmount: {
          amount: amount
        }
      }
    };
  } else {
    grouped[id].value.fixedAmount.amount += amount;
  }
});

// Convert amount back to string with 2 decimal places
const mergedArray = Object.values(grouped).map(item => {
  item.value.fixedAmount.amount = item.value.fixedAmount.amount.toFixed(2);
  return item;
});

//console.log(mergedArray);
    
      postDataDiscountArrayObject = mergedArray
    
    const cartAttributes = JSON.stringify(postDataDiscountArrayObject);

    if (!globalFieldsCartPage_AC.cartObj.attributes?.address_type || globalFieldsCartPage_AC.cartObj.attributes?.address_type == '') {
      document.querySelector('.address-error').style.display = 'block';
      makeEnableDisablebtn(true);
    const upsell_interval = setInterval(() => {
    ['lb-addon-popup-bg-id', 'lb-addon-popup-container-id'].forEach(id => {
        const el = document.getElementById(id);

        if (el) {
            el.style.display = 'none';
        }
    });
}, 100); // runs every 500ms

// stop after 5 seconds
setTimeout(() => {
    clearInterval(upsell_interval);
}, 6000);
      return
    }else{
      document.querySelector('.address-error').style.display = 'none';
    }

    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          Discountly_dateTime: cartAttributes,
        },
      }),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const updatedCart = await response.json();
   
    jQuery(".loading-overlay").addClass("hidden");

    // Now poll for checkout condition
    const intervalId = setInterval(() => {
      makeEnableDisablebtn(true);
      if (checkOutValid === true) {
        clearInterval(intervalId);
        makeEnableDisablebtn(false);
        window.location.href = '/checkout';
      }
    }, 100);

  } catch (error) {
    console.error('Failed to update cart:', error);
  }
}

  
    var UpdateCartItem = function (item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index,discountMsg) {
        if (isUpdate) {
            var originalItemPrice = globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), originalLinePrice = globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
            var condition1 = updatedItemPrice == originalItemPrice;
            updatedItemPrice = globalFields.ConvertToFixedDecimalString(updatedItemPrice), updatedLinePrice = globalFields.ConvertToFixedDecimalString(updatedLinePrice);

         var product_exclude = false;
              product_exclude =   globalFields.AllProductsMetafield != '[]' && globalFields.AllProductsMetafield.status ? isExcluded(item.product_id, globalFields.AllProductsMetafield?.excludeProducts) : product_exclude;
                 if (!product_exclude && discountMsg == '') { 
                    discountMsg = 'Trade+'
                 }
          if (originalCartObjData[index]?.original_price/100 != updatedItemPrice) {
            
          finalDiscountObj[item.key] = {
          variant_id: item.variant_id,
          tierPrice: originalCartObjData[index]?.original_price/100 - updatedItemPrice,
          discountMsg: discountMsg,
          qty:item.quantity 
          };
          }
            
              $('.cart_discount_price').hide()
          if (isNotInRange || condition1) {

                jQuery('.anncodeitemPirce').eq(index).html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
              if(window.location.pathname != '/cart'){
            /*Drawer*/   // jQuery('.mini_cart_meta').eq(index).html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
            /*Drawer*/    jQuery('.mini_cart_meta .cart_meta_price').eq(index).html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
               }           
     jQuery('.cart_items.js_cat_items .tc__.tr_lg ').eq(index).html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></div>');
            }
            else {
               
                
                originalItemPrice = globalFields.ConvertToFixedDecimalString(originalItemPrice), originalLinePrice = globalFields.ConvertToFixedDecimalString(originalLinePrice);
               jQuery('.anncodeitemPirce').eq(index).html('<div class="cart-item__original-price"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalItemPrice, globalFields.amount) + '</span></s></div> <div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
             if(window.location.pathname != '/cart'){
              /*Drawer*/ // jQuery('.mini_cart_meta').eq(index).html('<div class="cart-item__original-price"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalItemPrice, globalFields.amount) + '</span></s></div> <div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
              /*Drawer*/  jQuery('.mini_cart_meta .cart_meta_price').eq(index).html('<div class="cart-item__original-price"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalItemPrice, globalFields.amount) + '</span></s></div> <div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
                }      
      jQuery('.cart_items.js_cat_items .tc__.tr_lg ').eq(index).html('<div class="cart-item__original-price"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalLinePrice, globalFields.amount) + '</span></s></div> <div style="margin-left:5px"><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></div>');
             
               }
                          
        }

    }

    var UpdateCartSubtotal = function (isUpdate, updatedTotalPrice, originalTotalPrice) {
      
        if (isUpdate) {
           if(originalTotalPrice - updatedTotalPrice  < 0 ){updatedTotalPrice = originalTotalPrice}
            updatedTotalPrice = globalFields.ConvertToFixedDecimalString(updatedTotalPrice), originalTotalPrice = globalFields.ConvertToFixedDecimalString(originalTotalPrice);
            if (originalTotalPrice != updatedTotalPrice) {
               jQuery('.col-auto.tr.js_cat_ttprice.fs__20.fwb').replaceWith('<div class="col-auto tr js_cat_ttprice fs__20 fwb "><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalTotalPrice, globalFields.amount) + '</span></s> <span  class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span></div>');
  /*Drawer*/     jQuery('.drawertotal').replaceWith('<div class="drawertotal"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalTotalPrice, globalFields.amount) + '</span></s> <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span></div>');
            }
            else {
              jQuery('.col-auto.tr.js_cat_ttprice.fs__20.fwb').replaceWith('<div class="col-auto tr js_cat_ttprice fs__20 fwb "> <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span></div>');
  /*Drawer*/   jQuery('.drawertotal').replaceWith('<div class="drawertotal"><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span></div>');
            }
        }
                    
    }

    var UpdateSavingMessage = function (isUpdate) {
        if (priceDiff > 0 && isUpdate && globalFields.isCartPage) {
            var saveMessage = globalFields.settings.cart_saving_message.replace('{{discount_amount}}', '<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + priceDiff.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(priceDiff.toFixed(2), globalFields.amount) + '</span>');
            var saveHtml = '<span id="saved-banner">' + saveMessage + '</span>';
          if (jQuery(window).width() < 700) {
            jQuery('#saved-banner-div').length == 0 ? jQuery('.total').after('<div id="saved-banner-div" style="text-align: center;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
          }
          else{
            jQuery('#saved-banner-div').length == 0 ? jQuery('.total').after('<div id="saved-banner-div" style="text-align: end;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
          }
        }
        else if (globalFields.isCartPage) {
            jQuery('#saved-banner-div').remove();
        }
    }

var CheckoutClickCart = function () {
  jQuery('.cart__footer button[name="checkout"]')
    .off('click') // Remove previous handlers
    .on('click', async function (e) {
      e.preventDefault();
      e.target.innerText = 'Loading...';
      
      checkOutValid = false;
      await TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);
          // Now poll for checkout condition
    const intervalId = setInterval(() => {
      makeEnableDisablebtn(true);
      if (checkOutValid === true) {
        clearInterval(intervalId);
       setDateTimeInCart();
      }
    }, 100);

    });
};

var CheckoutClickAjax = function () {
  jQuery('.mini_cart_footer button[name="checkout"]')
    .off('click') // Remove previous handlers
    .on('click', async function (e) {
      e.preventDefault();
      e.target.innerText = 'Loading...';
      checkOutValid = false;
      await TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);
       const intervalId = setInterval(() => {
      makeEnableDisablebtn(true);
      if (checkOutValid === true) {
        clearInterval(intervalId);
       setDateTimeInCart();
      }
    }, 100);
    });
};

    var GetCode = async function (isUpper) {
      let VariantIdS = [];
      if (customerMemberOrNot === 'Trade+') {
          for (let i = 0; i < originalCartObjPrice.length; i++) {
            if(variantIdsToSend.length > 0){
              if ( variantIdsToSend.includes(originalCartObjPrice[i].variant_id)) {
                  minimumDiscountSubtotal += originalCartObjPrice[i].original_line_price;
                  priceDiff += originalCartObjPrice[i].original_line_price;
              }   else {
                  minimumDiscountSubtotal += originalCartObjPrice[i].original_line_price;
                  priceDiff += originalCartObjPrice[i].original_line_price;
                  VariantIdS.push(originalCartObjPrice[i].variant_id)
              }
            }
            else {
                  minimumDiscountSubtotal += originalCartObjPrice[i].original_line_price;
                  priceDiff += originalCartObjPrice[i].original_line_price;
              VariantIdS.push(originalCartObjPrice[i].variant_id)
              }
          }
          // priceDiff = Number(priceDiff.toFixed(2));
          // minimumDiscountSubtotal = Number(minimumDiscountSubtotal.toFixed(2));
           priceDiff = Number(priceDiff);
        
         // priceDiff = Number(Math.floor(priceDiff * 100) / 100);
          minimumDiscountSubtotal = Number(minimumDiscountSubtotal.toFixed(2));
      }

for (let i = 0; i < VariantIdS.length; i++) {
    let id = VariantIdS[i];
    
    // Only add if the ID is not already in variantIdsToSend
    if (!variantIdsToSend.includes(id)) {
        variantIdsToSend.push(id);
    }
}

  //    postDataDiscountArrayObject = DiscountObj

      return
      
        if (priceDiff >= 0 && variantIdsToSend.length > 0) {
            jQuery.ajax({
                type: "POST", async: false, url: "https://wholesale.apptiv.in/tier/ACPGenerateDiscountCodeCombined",
                data: { priceDifference: priceDiff, subTotal: minimumDiscountSubtotal, variantIds: variantIdsToSend.toString() },
                success: function (result) {
                    var data_ = JSON.stringify(result); var parsed_data = JSON.parse(data_); var PRID = parsed_data.PRID;
                    var DCID = parsed_data.DCID; var DiscountCode = parsed_data.DiscountCode;
                    SetCookie("discountCodes", PRID + "-" + DCID + "-" + DiscountCode, 30);
                    if (!isUpper) {
                        DiscountCodeCookie(DiscountCode);
                        jQuery('form[action="/cart"]').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                      	window.location.href = '/checkout?discount=' + DiscountCode;
                    } else {
                        DiscountCodeCookie(DiscountCode);
                        jQuery('form.cart-form').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                        window.location.href = '/checkout?discount=' + DiscountCode;
                    }
                },
                error: function (e) { console.log(e.statusText);  window.location.href = '/checkout?discount=' + 'NODISCOUNT'; }
            });
        }
        else if (isUpper) {
                window.location.href = '/checkout?discount=' + 'NODISCOUNT';
        }
      else{
             window.location.href = '/checkout?discount=' + 'NODISCOUNT';
      }
    }

    var ReInvokeAjaxCartButton = function () {
        jQuery('.mb_cart.mb_item button.btn, .top-header .dropdown-cart button.btn').off("click"); CheckoutClickAjax();
    }

    var variantIdsToSend = [], minimumDiscountSubtotal = 0, priceDiff = 0;

  	var hide_buttons = null;
  	var HideAdditionalPayments = function() {      
      hide_buttons = setInterval(function() {
        if(jQuery('.additional_checkout_buttons, .dynamic-checkout__content').length>0){
          jQuery('.additional_checkout_buttons, .dynamic-checkout__content').hide();
          clearInterval(hide_buttons);
        }
      }, 500);
    }
  
    var TieredPricingCart = async function (cartObject, isUpdate) {

      postDataDiscountArrayObject = [];

        variantIdsToSend = []; minimumDiscountSubtotal = 0; priceDiff = 0; var updatedTotalPrice = 0;
        for (k = 0; k < cartObject.items.length; k++) {
            var item = cartObject.items[k], isInRange = true; itemTiers = GetTiersFromTiersArray(item.variant_id);
          
          if (itemTiers != undefined && itemTiers.status && globalFields.StartEndDateValid(itemTiers.start_date, itemTiers.end_date)) {
            
            let DiscountAppliedOn = itemTiers.DiscountAppliedON != null &&  itemTiers.DiscountAppliedON  != '' &&  itemTiers.DiscountAppliedON != undefined ? true : false;
            let Location_Tag_s = itemTiers.Location_Tag_ != null &&  itemTiers.Location_Tag_  != '' &&  itemTiers.Location_Tag_ != undefined ? true : false;
               if(DiscountAppliedOn){
                if(Location_Tag_s){
                   let DiscountAppliedOnTag =itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ? true : false;
                   let LocationObject = Object.keys(itemTiers.Location_Tag_);
                   if(LocationObject[0] == 'StoreLocation'){
                    let StoreLocationcheck =  itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecountry) || itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecity) ? true : false;
                    if(StoreLocationcheck && DiscountAppliedOnTag){
                        var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                        updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                        if (rslt[1]) {
                        updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                        }
                      }else{
                      updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                      }
                   }else{
                   let TierLocation = itemTiers.Location_Tag_[LocationObject[0]];
                   let CusotmerCountryLocation = globalFields.Customercountry;
                   let CusotmerCityLocation = globalFields.Customercity;
                   let CustomerLocationcheck_1 = (arr, arr1) =>{return arr.some(item => arr1.includes(item))};
                   let CustomerLocationcheck_2 = (arr2, arr3) =>{return arr2.some(item => arr3.includes(item))};
                   let CityValue = CustomerLocationcheck_1(TierLocation,CusotmerCountryLocation);
                   let CountryValue = CustomerLocationcheck_2(TierLocation,CusotmerCityLocation);
                     if(DiscountAppliedOnTag && (CityValue || CountryValue)){
                        var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                        updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                        if (rslt[1]) {
                        updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                        }
                     }else{
                       updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                     }
                   }
                                                   
                 }else{
                  if(itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ){
                   var rslt =  CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                  updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                  if (rslt[1]) {
                  updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                  }
                 }else{
                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                 }
                 }
                 
               }else{
                var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                if (rslt[1]) {
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                }
                 
               }

            
             }
            else if(!TradeCustomer){
              updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price/100);
                UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), true, isUpdate, k,'');
            }
            else {
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price/100);
                //updatedTotalPrice = updatedTotalPrice/100;
            }
          
            if (!isInRange) {
                minimumDiscountSubtotal += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100); variantIdsToSend.push(item.variant_id);
            }
          
        }
        UpdateCartSubtotal(isUpdate, globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice), globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100));
        priceDiff = globalFields.ConvertToFixedDecimalNumber((globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100) - globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice)));
        UpdateSavingMessage(isUpdate);
         makeEnableDisablebtn(false)
     
      	if(priceDiff){
          HideAdditionalPayments();
        }
      	setTimeout(function(){
          clearInterval(hide_buttons);
        }, 5000);
    checkOutValid = true
    }
setTimeout(function(){
      clearInterval(hide_buttons);
    }, 10000);
    
var GetTiersFromTiersArray = function (variantId) {
    var tierObj = jQuery.grep(
        globalFieldsCartPage_AC.cartTiersArray,
        function (n) {
            return n.variant_id === variantId;
        }
    );

    if (!tierObj || tierObj.length == 0 || tierObj?.[0]?.tiers == "[]") {
        return undefined;
    } else {
        return globalFields.GetTierObject(
            tierObj[0].tiers[0],
            variantId
        );
    }
}

    var CalculateTier = function (item, itemTiers, updatedTotalPrice, isUpdate, isNotInRange, index) {
        for (i = 0; i < itemTiers.tier_min.length; i++) {
            var allVariantItemQty = 0;
            var tierPrice = parseFloat(itemTiers.tier_values[i]);
            var minTier = parseInt(itemTiers.tier_min[i]), maxTier = itemTiers.tier_max[i] != 'max' ? parseInt(itemTiers.tier_max[i]) : itemTiers.tier_max[i];
            var updatedItemPrice = 0, updatedLinePrice = 0, condition1 = false, condition2 = false;

            if (itemTiers.entity_type === 'products' || itemTiers.entity_type === 'collections') {
                var tempItemArray = [];
                if (itemTiers.entity_type === 'collections') {
                    var tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.tiers != '[]' && n.tiers[0].entity_type == 'collections' && n.tiers[0].entity_id == itemTiers.entity_id); });
                    for (var m = 0; m < tempTierArray.length; m++) {
                        var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.variant_id == tempTierArray[m].variant_id); });
                        if (temp.length != 0) {
                            tempItemArray.push(temp[0]);
                        }
                    }
                }
                else {
                    tempItemArray = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.product_id == item.product_id ); });
                }

                for (j = 0; j < tempItemArray.length; j++) { allVariantItemQty += tempItemArray[j].quantity; }
                condition1 = allVariantItemQty >= minTier;
                condition2 = maxTier == "max" || allVariantItemQty <= maxTier;
            }
            else {
                condition1 = item.quantity >= minTier;
                condition2 = maxTier == "max" || item.quantity <= maxTier;
            }

            if (condition1 && condition2) {
                isNotInRange = false;
                if (itemTiers.discount_type == 'percentage') {
                    var originalPriceCut = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(item.original_price / 100)));
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - originalPriceCut);
                }
                else if (itemTiers.discount_type == 'fixed') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - parseFloat(tierPrice));
                }
                else if (itemTiers.discount_type == 'fixed_price') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice));
                }

                if (updatedItemPrice < 0) { updatedItemPrice = 0; }
                updatedLinePrice = globalFields.ConvertToFixedDecimalNumber(updatedItemPrice * item.quantity);
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(updatedLinePrice);
                UpdateCartItem(item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index,discountMsg);
            }
        }
        if (isNotInRange) {
            UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), isNotInRange, isUpdate, index,'');
        }
        return [updatedTotalPrice, isNotInRange];
    }

    var DiscountCodeCookie = function (discount_code) {
        jQuery.ajax({
            type: "HEAD", url: "/discount/" + discount_code,
            success: function (_result) { },
            error: function (e) { console.log(e.statusText); }
        })
    }

    var FetchCartTiers = function () {
        jQuery.ajax({
            async: false,
            url: "/cart/?view=ac_cart_tiers",
            success: function (result) {
                globalFieldsCartPage_AC.cartTiersArray = JSON.parse(result);
                customerHasTag(globalFieldsCartPage_AC.cartObj)
                TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
            },
            error: function (e) { console.log(e.statusText); }
        });
    }
    /*
        var open = window.XMLHttpRequest.prototype.open, send = window.XMLHttpRequest.prototype.send, onReadyStateChange;
        function openReplacement(method, url, async, user, password) { return open.apply(this, arguments); }
        function sendReplacement(data) {
            this.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    ProcessCartResponse(this._url, this.responseText);
                }
            };
            return send.apply(this, arguments);
        }
        window.XMLHttpRequest.prototype.open = openReplacement; window.XMLHttpRequest.prototype.send = sendReplacement;
    */
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
        ProcessCartResponse(settings.url, xhr.responseText);
     
    });


     // =========================
  // INTERCEPT XHR
  // =========================
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._url = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this._url && this._url.includes("/cart/add.js")) {
      console.log("Intercepted XHR /cart/add.js");

      this.addEventListener("load", function () {
        let responseData = null;

        try {
          // responseData = JSON.parse(this.responseText);
          customAddToCart();
        } catch (e) {}

      });
    }

    return originalSend.apply(this, arguments);
  };

async function customAddToCart() {
   makeEnableDisablebtn(true)
                setTimeout(function () {
                       finalDiscountObj = []
                    fetch('/cart.js')
                        .then(r => r.json().then(data => ({ status: r.status, body: data })))
                        .then(obj => ProcessCartResponse("/cart.js", JSON.stringify(obj.body)))
                        .catch(error => {
                            console.error('Error processing /cart.js response:', error);
                        });
                }, 1500);
}


    var ProcessCartResponse = function (splittedUrl, responseText) {
        if (splittedUrl != 'undefined' && splittedUrl != "" && splittedUrl != null) {
            splittedUrl = splittedUrl.split("?");
            
                      if (splittedUrl[0].includes("/add")) {
            
          }
            if (splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js" ) {
                originalCartObjData = JSON.parse(responseText);
                globalFieldsCartPage_AC.cartObj = JSON.parse(responseText);
                setTimeout(function () {
                    FetchCartTiers();
                }, 800);
            }
        }
    }

try {
    var nativeFetch = window.fetch;
    window.fetch = function (...args) {
        try {
            if (args[0] && typeof args[0] === 'string' && (args[0].includes("/cart/change") || args[0].includes("/cart/add"))) {
               makeEnableDisablebtn(true)
                setTimeout(function () {
                       finalDiscountObj = []
                    fetch('/cart.js')
                        .then(r => r.json().then(data => ({ status: r.status, body: data })))
                        .then(obj => ProcessCartResponse("/cart.js", JSON.stringify(obj.body)))
                        .catch(error => {
                            console.error('Error processing /cart.js response:', error);
                        });
                }, 1500);
            }
        } catch (error) {
            console.error('Error in fetch override:', error);
        }

        return nativeFetch.apply(window, args);
    };
} catch (e) {
    console.error('Error setting up fetch override:', e);
}
function isExcluded(cartId, excludeProducts) {
    return excludeProducts.some(product => product.id == cartId);
}
  

customerHasTag(globalFieldsCartPage_AC.cartObj)
  function customerHasTag(cartObject) {
    originalCartObjData = JSON.parse(JSON.stringify(cartObject.items));
              originalCartObjPrice = [];
            if (TradeCustomer) {
              let original_total_price = 0;
              for (k = 0; k < cartObject.items.length; k++) {

                let tempCartObjPrice = {};
              var item = cartObject.items[k],original_line_price = 0,original_price = 0;itemTiers = GetTiersFromTiersArray(item.variant_id);
             var product_exclude = false;
              product_exclude =   globalFields.AllProductsMetafield != '[]' && globalFields.AllProductsMetafield.status ? isExcluded(item.product_id, globalFields.AllProductsMetafield?.excludeProducts) : product_exclude;
             let tierDiscountAmount =  globalFields.AllProductsMetafield != '[]' && globalFields.AllProductsMetafield.status ? Number(globalFields.AllProductsMetafield.tier_values[0]): 0
                 if (product_exclude) { 
                   original_total_price += item.original_line_price
                    UpdateCartItem(item,item.original_price/100,item.original_line_price/100, true, true, k,'');
                   continue}
                let discountOriginalPrice = (item.original_price*tierDiscountAmount/100)/100;
                let discountOriginalLinePrice = (item.original_line_price*tierDiscountAmount/100)/100;
                tempCartObjPrice.original_price = Number(discountOriginalPrice);
                tempCartObjPrice.original_line_price = Number(discountOriginalLinePrice);
                tempCartObjPrice.variant_id = item.variant_id;
                
                
               original_price = item.original_price*tierDiscountAmount/100;
               original_price = item.original_price - original_price
              original_price =  globalFields.ConvertToFixedDecimalNumber((original_price/100));
              original_price =  globalFields.ConvertToFixedDecimalNumber((original_price*100));
                
              //original_line_price = item.original_line_price*tierDiscountAmount/100;
             // original_line_price =  item.original_line_price - original_line_price;
              original_line_price = original_price*item.quantity;
              // original_line_price =  item.original_line_price - original_line_price;
                
              globalFieldsCartPage_AC.cartObj.items[k].original_line_price  = original_line_price; 
              globalFieldsCartPage_AC.cartObj.items[k].original_price = original_price;
              original_total_price += original_line_price
                  if (itemTiers == undefined || !itemTiers.status || !globalFields.StartEndDateValid(itemTiers.start_date, itemTiers.end_date)) {
                    original_price = (original_price/100);
                    original_price = Number(original_price);
                    
                    original_line_price = (original_line_price/100)
                    original_line_price = Number(original_line_price);
                   UpdateCartItem(item,original_price,original_line_price, true, true, k,'Trade+');

                }
                 originalCartObjPrice.push(tempCartObjPrice)
              }
              //tempCartObjPrice.original_total_price = globalFieldsCartPage_AC.cartObj.original_total_price;
             
              
              globalFieldsCartPage_AC.cartObj.original_total_price = original_total_price
          }
  }
var perfEntries = performance.getEntriesByType("navigation");
if (perfEntries[0].type === "back_forward" && window.location.href.includes('/cart')) {
  setTimeout(() => {
 location.reload();
// location.reload();
}, 700);
}
// Option 1: Force reload on back/forward navigation
window.addEventListener('pageshow', function (event) {
  if ((event.persisted || (window.performance && window.performance.navigation.type === 2)&&  window.location.href.includes('/cart') )) {
    console.log('Detected back navigation. Reloading cart...');
    window.location.reload();
  }
});
  
  $(document).ready(function () {
    $(document).on("keyup", `.mini_cart_wrap .quantity input[type="number"],.cart_items  .quantity input[type="number"]`, function () {

      makeEnableDisablebtn(true)
      setTimeout(() => {
        $(this).blur(); // Triggers the blur event
      }, 800);
    });

    $(document).on("blur", `.mini_cart_wrap .quantity input[type="number"],.cart_items  .quantity input[type="number"]`, function () {
     // console.log('blur')
      setTimeout(() => {
        makeEnableDisablebtn(true)
         TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
      }, 2000);


    });
  });

  jQuery(document).ready(function () {
    jQuery('.cart_items  .quantity button[type="button"],.mini_cart_wrap  .quantity button[type="button"]').on('click', function (event) {
      event.preventDefault(); // Prevent default behavior (if any)
      makeEnableDisablebtn(true)
    });
  });
  jQuery('.cart_items  .quantity button[type="button"],.mini_cart_wrap  .quantity button[type="button"]').on('click', function (event) {
    event.preventDefault(); // Prevent default behavior (if any)
    makeEnableDisablebtn(true)
  });
  
  
  function makeEnableDisablebtn(isEnable) {

    if(isEnable){
       jQuery('.cart__footer button[name="checkout"]').prop('disabled', true);
 //     jQuery('.page-cart .cart-right button[name="checkout"]').prop('disabled', true);
      jQuery('.cart__footer button[name="checkout"]').text('\n                    \n                      Loading...\n                    \n                  '); 
    //  jQuery('.drawer-bottom button[name="checkout"]').text('\n                    \n                      Loading...\n                    \n                  ')
     

    }else{
      jQuery('.cart__footer button[name="checkout"]').text('\n                    \n                      Check out\n                    \n                  ')
   //   jQuery('.drawer-bottom button[name="checkout"]').text('\n                    \n                      Checkout\n                    \n                  ')
  //    jQuery('.drawer-bottom button[name="checkout"]').prop('disabled', false);
      jQuery('.cart__footer button[name="checkout"]').prop('disabled', false);
    }

  }
  
    var SetCookie = function (cname, cvalue, exdays) { var d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); var expires = "expires=" + d.toUTCString(); document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; }
     hasCoustomerTag();TieredPricingCart(globalFieldsCartPage_AC.cartObj, true); CheckoutClickCart(); CheckoutClickAjax(); 
        window.addEventListener('load', function () {
        setTimeout(function () {
           hasCoustomerTag()
            TieredPricingCart(globalFieldsCartPage_AC.cartObj, true); CheckoutClickCart(); CheckoutClickAjax(); 
          }, 2000);
         

//when the dom Loads the new html
          })
        }

var globalFieldsCartPage_AC = new ACDiscountApp.CartPage.Global(); var cartObject = new ACDiscountApp.CartPage.Show_CalculateTier();
